import jwtDecode from 'jwt-decode';

export const getClaims = (token: string): Record<string, any> => {
  if (!token) {
    return {};
  }

  const claims = jwtDecode<Record<string, any>>(token);

  return claims;
};

export const areCredentialsValid: (
  credentials: Partial<Bluebeam.Auth.Models.Credentials>
) => asserts credentials is Bluebeam.Auth.Models.Credentials = (
  credentials
) => {
  if (!credentials) {
    throw new Error('A set of credentials are required');
  }

  if (!credentials.accessToken || credentials.accessToken === '') {
    throw new Error('An access token is required');
  }

  if (!credentials.idToken || credentials.idToken === '') {
    throw new Error('An id token is required');
  }

  if (!credentials.email || credentials.email === '') {
    throw new Error('An email is required');
  }

  if (!credentials.userId || credentials.userId === '') {
    throw new Error('A user identifier is required');
  }
};

export const convertTokensToCredentials = (
  accessToken: string,
  idToken: string,
  refreshToken?: string,
  idTokenClaims?: Record<string, any>
): Partial<Bluebeam.Auth.Models.Credentials> => {
  const sanitizedAccessToken = accessToken.trim() ?? '';

  if (sanitizedAccessToken === '') {
    throw new Error('An access token is required');
  }

  const sanitizedIdToken = idToken.trim() ?? '';

  if (sanitizedIdToken === '') {
    throw new Error('An id token is required');
  }

  let sanitizedRefreshToken = refreshToken?.trim();

  if (sanitizedRefreshToken === '') {
    sanitizedRefreshToken = undefined;
  }

  const userClaims = idTokenClaims ?? getClaims(sanitizedIdToken);

  const email =
    userClaims.email?.trim() ?? userClaims.preferred_username?.trim() ?? '';

  if (email === '') {
    throw new Error('An email is required');
  }

  // TODO: BBCLD-8618 Improve the experience for users with missing claims
  let firstName = userClaims.firstName?.trim();
  let lastName = userClaims.lastName?.trim();
  let displayName = userClaims.name?.trim();

  // Handle missing or blank first, last, and displayNames:
  if (!firstName || firstName.length === 0) {
    firstName = 'First';
  }

  if (!lastName || lastName.length === 0) {
    lastName = 'Last';
  }

  if (!displayName || displayName.length === 0) {
    displayName = `${firstName} ${lastName}`.trim();
  }

  const userId = userClaims.bbid?.trim() ?? userClaims.sub?.trim() ?? '';

  if (userId === '') {
    throw new Error('A user identifier is required');
  }

  return {
    accessToken: sanitizedAccessToken,
    email,
    displayName,
    idToken: sanitizedIdToken,
    refreshToken: sanitizedRefreshToken,
    userId,
  };
};
